import CheckInDayConfirmContent from './CheckInDayConfirmContent';

export default CheckInDayConfirmContent;
